import DOMPurify from "dompurify";
import { useMemo } from "react";

const ALLOWED_TAGS = [
    "b",
    "i",
    "u",
    "strong",
    "em",
    "p",
    "br",
    "span",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "ul",
    "ol",
    "li",
    "blockquote",
    "pre",
    "code",
    "table",
    "thead",
    "tbody",
    "tr",
    "th",
    "td",
    "figure",
    "figcaption",
    "hr",
    "div"
];

const ALLOWED_ATTR = ["title", "alt", "height", "width", "class", "id", "style", "data-*"];

const ALLOWED_CSS_PROPERTIES = [
    "color",
    "background-color",
    "text-align",
    "font-weight",
    "font-style",
    "text-decoration",
    "padding-left",
    "margin",
    "margin-left",
    "margin-right",
    "display"
];

function sanitizeCss(styleString = "") {
    if (!styleString) return "";

    const allowed = [];

    styleString.split(";").forEach(rule => {
        const [prop, value] = rule.split(":").map(x => x && x.trim());
        if (!prop || !value) return;
        if (ALLOWED_CSS_PROPERTIES.includes(prop.toLowerCase())) {
            allowed.push(`${prop}: ${value}`);
        }
    });

    return allowed.join("; ");
}

export const sanitizeHtml = (raw = "") => {
    if (!raw) return "";

    let html = raw;

    const containsHtmlTags = /<\/?[a-z][\s\S]*>/i.test(raw);

    if (!containsHtmlTags) {
        html = raw.replace(/(?:\r\n|\r|\n)/g, "<br>");
    }

    DOMPurify.setConfig({
        ALLOWED_TAGS,
        ALLOWED_ATTR,
        FORBID_TAGS: ["img", "a", "iframe", "script", "object", "embed"],
        ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto):|\/)/i
    });

    DOMPurify.addHook("uponSanitizeAttribute", (node, data) => {
        const { attrName, attrValue } = data;

        if (attrName === "href" || attrName === "src") {
            node.removeAttribute(attrName);
            return;
        }

        if (attrName === "style") {
            const cleanStyle = sanitizeCss(attrValue);
            if (!cleanStyle) node.removeAttribute("style");
            else node.setAttribute("style", cleanStyle);
        }
    });

    return DOMPurify.sanitize(html);
};

export const SafeHtmlNoImgNoLink = ({ html = "", className = "", fallback = "-" }) => {
    const clean = useMemo(() => sanitizeHtml(html), [html]);

    const output = clean || (html ? String(html).replace(/</g, "&lt;") : fallback);

    return <div className={className} dangerouslySetInnerHTML={{ __html: output }} />;
};
